import { useMemo, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import queryString from "qs";
import { createUrl } from "@common/utils/url-utils";

export function useRouterWeb() {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Memoize the router object to prevent unnecessary re-renders
  const router = useMemo(() => {
    return {
      // For convenience add push(), replace(), pathname at top level
      navigate: (pathname: string, query: Record<string, unknown> = {}) => {
        const url = createUrl(pathname, query);
        navigate(url);
      },
      pathname: location.pathname,
      // Merge params and parsed query string into single "query" object
      query: {
        ...params,
        ...queryString.parse(location.search.substring(1)), // Convert string to object
      },
      // Include match, location, history objects so caller
      // can use object destructuring to get anything needed
      location,
      history: navigate,
    };
  }, [navigate, location, params]);

  return router;
}
